import { createAsyncThunk } from '@reduxjs/toolkit';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/events/event.response.type';
import * as Request from '@shared/models/events/event.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';
import { setPopularEventList, setUpcomingEventList } from '../slices';

export const EventEndpoints = {
    getPopularEventList: config.base_url + '/events/popular',
    getUpcomingEventList: config.base_url + '/events/upcoming',
};

export const fetchPopularEventList = createAsyncThunk<void, Request.IPopularEventListRequest>(
    EventEndpoints.getPopularEventList,
    async (query, { dispatch }) => {
        try {
            const res = await httpService.post<AscResponse<Response.IPopularEventListResponse>>(
                `${EventEndpoints.getPopularEventList}`
            );

            dispatch(setPopularEventList(res.data.data));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(
                    err,
                    `Error fetching popular event list, query: ${EventEndpoints.getPopularEventList}`
                ),
                {
                    type: 'error',
                }
            );
        }
    }
);

export const fetchUpcomingEventList = createAsyncThunk<void, Request.IUpcomingEventListRequest>(
    EventEndpoints.getUpcomingEventList,
    async (query, { dispatch }) => {
        try {
            const res = await httpService.post<AscResponse<Response.IUpcomingEventListResponse>>(
                `${EventEndpoints.getUpcomingEventList}`
            );

            dispatch(setUpcomingEventList(res.data.data));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(
                    err,
                    `Error fetching upcoming event list, query: ${EventEndpoints.getUpcomingEventList}`
                ),
                {
                    type: 'error',
                }
            );
        }
    }
);
